import { render, staticRenderFns } from "./JobTabs.vue?vue&type=template&id=2e668978&scoped=true"
import script from "./JobTabs.vue?vue&type=script&lang=js"
export * from "./JobTabs.vue?vue&type=script&lang=js"
import style0 from "./JobTabs.vue?vue&type=style&index=0&id=2e668978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e668978",
  null
  
)

export default component.exports